namespace TabAurous.Retail {
    export namespace POSSalesWithoutTaxItemsService {
        export const baseUrl = 'POSSales/POSSalesWithoutTaxItems';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<POSSalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "POSSales/POSSalesWithoutTaxItems/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>POSSalesWithoutTaxItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
